import { render } from "./SpellView.vue?vue&type=template&id=13ba02b6&scoped=true"
import script from "./SpellView.vue?vue&type=script&lang=js"
export * from "./SpellView.vue?vue&type=script&lang=js"

import "./SpellView.vue?vue&type=style&index=0&id=13ba02b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ba02b6"]])

export default __exports__